import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/expenses/Data Table";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Add_data_modal from "../../components/expenses/update_data_modal";
import Layouts from "../../layouts/layouts";
import ExpenseDetailModal from "../../components/expenses/Expense Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import Switch from "react-switch";

export default function Expense() {
  const title = "Expense Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showExpenseDetailModal, setShowExpenseDetailModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [expenseCount, setExpenseCount] = useState(0);
  const [expenseSummary, setExpenseSummary] = useState({
    totalExpense: 0,
    totalApprovedCount: 0,
    totalPendingCount: 0,
  });
  const [dataFilter, setDataFilter] = useState("");
  const [employeeFilter, setEmployeeFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [hubFilter, setHubFilter] = useState("");
  const [vehicleFilter, setVehicleFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loadingExport, setLoadingExport] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportFromDate, setExportFromDate] = useState("");
  const [exportToDate, setExportToDate] = useState("");

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>User Name</b>,
      selector: (row) => (row.id_user ? row.id_user.name : "N/A"),
      sortable: true,
    },

    {
      name: <b>Hubs</b>,
      selector: (row) => (row.id_hub ? row.id_hub.name : "N/A"),
      sortable: true,
    },
    {
      name: <b>Category</b>,
      selector: (row) =>
        row.id_expenseCategory ? row.id_expenseCategory.name : "N/A",
      sortable: true,
    },
    {
      name: <b>Amount </b>,
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: <b>Date </b>,
      selector: (row) => formatDate(row.date),
      sortable: true,
    },
    {
      name: <b>IS Online?</b>,
      selector: (row) => (row.isOnline ? "True" : "False"),
      cell: (row) => (
        <Switch
          onChange={() => handleToggleIsOnline(row)}
          checked={row.isOnline}
        />
      ),
      sortable: true,
    },

    {
      name: <b>Transaction Type</b>,
      cell: (row) => {
        const transactionType = row.stransactionTypetatus?.toLowerCase();
        return (
          <button
            onClick={() => handleShow(row)}
            className={`btn p-0 px-1 ${
              transactionType === "credit"
                ? "btn-success"
                : transactionType === "debit"
                  ? "btn-danger"
                  : ""
            }`}
          >
            {row.transactionType || "Unknown"}
          </button>
        );
      },
    },
    {
      name: <b>Account Number</b>,
      selector: (row) => row.id_user?.bank_details?.account_number || "-",
      sortable: true,
    },
    {
      name: <b>Approved</b>,
      selector: (row) => (row.approved ? "True" : "False"),
      cell: (row) => (
        <Switch
          onChange={() => handleToggleApproved(row)}
          checked={row.approved}
        />
      ),
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {row.status === "created" && (
            <>
              <button
                onClick={() => copyLink()}
                className=" btn btn-success btn-sm"
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
              <button className=" btn btn-primary btn-sm ms-1">
                <FontAwesomeIcon icon={faEnvelope} />
              </button>
            </>
          )}
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className=" btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => delete_row(row)}
            className=" btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
          <button
            onClick={() => viewExpense(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const handleToggleApproved = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedApproved = !row.approved;

      // Send JSON instead of FormData
      const data = {
        approved: updatedApproved,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expense/${row._id}`,
        data, // send as JSON

        {
          headers: {
            "Content-Type": "application/json", // JSON header
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        // Update the apistate with the new isOnline value
        const updatedApiState = apistate.map((expense) =>
          expense._id === row._id
            ? { ...expense, approved: updatedApproved }
            : expense,
        );
        setApiState(updatedApiState); // Ensure apistate is updated correctly
        Swal.fire("Updated!", "Approved status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Is Approved status.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating approved status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating approved status.",
        "error",
      );
    }
  };

  const handleToggleIsOnline = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedIsOnline = !row.isOnline;

      // Send JSON instead of FormData
      const data = {
        isOnline: updatedIsOnline,
      };

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expense/${row._id}`,
        data, // send as JSON

        {
          headers: {
            "Content-Type": "application/json", // JSON header
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200) {
        // Update the apistate with the new isOnline value
        const updatedApiState = apistate.map((expense) =>
          expense._id === row._id
            ? { ...expense, isOnline: updatedIsOnline }
            : expense,
        );
        setApiState(updatedApiState); // Ensure apistate is updated correctly
        Swal.fire("Updated!", "Is Online status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Is Online status.",
          "error",
        );
      }
    } catch (error) {
      console.error("Error updating online status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating online status.",
        "error",
      );
    }
  };

  const fetchExpenses = async (page = 1, limit = 5) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) return;

      let query = `?page=${page}&limit=${limit}`;

      if (dataFilter) query += `&search=${dataFilter}`;

      if (employeeFilter) query += `&employee=${employeeFilter}`;

      if (categoryFilter) query += `&category=${categoryFilter}`;

      if (hubFilter) query += `&hub=${hubFilter}`;

      if (vehicleFilter) query += `&numberplate=${vehicleFilter}`;

      if (startDate && endDate) {
        query += `&startDate=${startDate}&endDate=${endDate}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expenses${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setApiState(response.data.data || []);
      setExpenseCount(response.data.pagination?.totalExpenses || 0);
      setExpenseSummary(
        response.data.summary || {
          totalExpense: 0,
          totalApprovedCount: 0,
          totalPendingCount: 0,
        },
      );
      setApiCol(columns);

      // optional
      console.log(response.data.summary);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchExpenses(currentPage, rowsPerPage);
  }, [
    currentPage,
    rowsPerPage,
    dataFilter,
    employeeFilter,
    categoryFilter,
    hubFilter,
    vehicleFilter,
    startDate,
    endDate,
  ]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You wont be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/v1/expense/${row._id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(() => {
            Swal.fire("Deleted!", "Expense has been deleted.", "success");
            fetchExpenses(currentPage, rowsPerPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Expense could not be deleted.", "error");
            console.error("Error deleting expenses:", error);
          });
      }
    });
  };

  const updateExpense = (updatedExpense) => {
    setApiState((prev) =>
      prev.map((expense) =>
        expense._id === updateExpense._id ? updateExpense : expense,
      ),
    );
  };

  const handleUpdateExpense = (updatedExpenseData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expense/${updatedExpenseData._id}`,
        updatedExpenseData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        Swal.fire("Updated!", "Expense details have been updated.", "success");
        updateExpense(response.data.expense);
      })
      .catch((error) => {
        Swal.fire("Error!", "Expense details could not be updated.", "error");
        console.error(
          "Error updating expense:",
          error.response ? error.response.data : error.message,
        );
      });
  };

  const viewExpense = (expense) => {
    setSelectedExpense(expense);
    setShowExpenseDetailModal(true);
  };
  const handleExport = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) return;

      setLoadingExport(true);

      let query = "?";

      if (exportFromDate && exportToDate) {
        query += `startDate=${exportFromDate}&endDate=${exportToDate}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/expenses${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const expenses = response.data.data || [];

      const transformedData = expenses.map((expense, index) => ({
        "S.No": index + 1,
        "User Name": expense.id_user?.name || "-",
        "Account Number": expense.id_user?.bank_details?.account_number || "-",
        "Bank Name": expense.id_user?.bank_details?.bank_name || "-",
        IFSC: expense.id_user?.bank_details?.ifsc_code || "-",
        "Account Holder":
          expense.id_user?.bank_details?.account_holder_name || "-",
        Hub: expense.id_hub?.name || "-",
        Category: expense.id_expenseCategory?.name || "-",
        Amount: expense.amount,
        Date: expense.date,
        Transaction: expense.transactionType,
        Online: expense.isOnline ? "Yes" : "No",
        Approved: expense.approved ? "Yes" : "No",
        Comments: expense.comments || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(transformedData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");

      XLSX.writeFile(workbook, "expenses.xlsx");

      setShowExportModal(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingExport(false);
    }
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateExpense={updateExpense}
      />
      <ExpenseDetailModal
        show={showExpenseDetailModal}
        onHide={() => setShowExpenseDetailModal(false)}
        expense={selectedExpense}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between align-items-center border-bottom pb-1">
                {/* Title */}
                <h4 className="mb-0">{title}</h4>

                <div className="d-flex align-items-center gap-2">
                  {/* Total Expense */}
                  <span
                    className="btn btn-secondary btn-sm text-white"
                    style={{ cursor: "default" }}
                  >
                    TOTAL EXPENSE: ₹{" "}
                    {Number(expenseSummary.totalExpense || 0).toLocaleString(
                      "en-IN",
                    )}
                  </span>

                  {/* Approved */}
                  <span
                    className="btn btn-success btn-sm text-white"
                    style={{ cursor: "default" }}
                  >
                    APPROVED: {expenseSummary.totalApprovedCount || 0}
                  </span>

                  {/* Pending */}
                  <span
                    className="btn btn-warning btn-sm text-white"
                    style={{ cursor: "default" }}
                  >
                    PENDING: {expenseSummary.totalPendingCount || 0}
                  </span>

                  {/* Add Expense */}
                  <Link to="/create_expense">
                    <div className="btn btn-info btn-sm text-white">
                      Add Expense
                    </div>
                  </Link>

                  {/* Export */}
                  <button
                    onClick={() => setShowExportModal(true)}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              {showExportModal && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Select Date Range</h5>

                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowExportModal(false)}
                        />
                      </div>

                      <div className="modal-body">
                        <div className="mb-3">
                          <label>From Date</label>

                          <input
                            type="date"
                            className="form-control"
                            value={exportFromDate}
                            onChange={(e) => setExportFromDate(e.target.value)}
                          />
                        </div>

                        <div>
                          <label>To Date</label>

                          <input
                            type="date"
                            className="form-control"
                            value={exportToDate}
                            onChange={(e) => setExportToDate(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary"
                          onClick={() => setShowExportModal(false)}
                        >
                          Cancel
                        </button>

                        <button
                          className="btn btn-success"
                          onClick={handleExport}
                          disabled={loadingExport}
                        >
                          {loadingExport ? "Please wait..." : "Export"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="card-body">
                <DataTable_Component
                  searchBy="name"
                  title_btn={true}
                  apidata={apistate}
                  columns={apicol}
                  totalRows={expenseCount}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                  dataFilter={dataFilter}
                  setDataFilter={setDataFilter}
                  employeeFilter={employeeFilter}
                  setEmployeeFilter={setEmployeeFilter}
                  categoryFilter={categoryFilter}
                  setCategoryFilter={setCategoryFilter}
                  hubFilter={hubFilter}
                  setHubFilter={setHubFilter}
                  vehicleFilter={vehicleFilter}
                  setVehicleFilter={setVehicleFilter}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  noDataComponent={
                    <div className="text-center py-4">No expenses found.</div>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
